import { render, staticRenderFns } from "./SmsPointSummary.vue?vue&type=template&id=752d3fe6&"
import script from "./SmsPointSummary.vue?vue&type=script&lang=ts&"
export * from "./SmsPointSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports